import { render, staticRenderFns } from "./_CreateAction.vue?vue&type=template&id=4c2685ad&scoped=true&"
import script from "./_CreateAction.vue?vue&type=script&lang=ts&"
export * from "./_CreateAction.vue?vue&type=script&lang=ts&"
import style0 from "./_CreateAction.vue?vue&type=style&index=0&id=4c2685ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2685ad",
  null
  
)

export default component.exports